import React from "react";
import { Button } from "@mui/material";



const CustomButton = ({ myFunction, text }) => {

    return (
        <Button
          variant="contained"
          color="primary"
          size="large"
          className="flex items-center"
          fullWidth
          onClick={myFunction}
          sx={{ padding: 1.3, borderRadius: "40px" }}>
          {text}
        </Button>
    )
}

export default CustomButton;